import { defineMessages } from "react-intl";

const ACCOUNT_CARD = "account-card";

const accountCardMessages = defineMessages({
  zeroItems: {
    id: `${ACCOUNT_CARD}.zero-items`,
    defaultMessage: "0 items"
  },
  showMore: {
    id: `${ACCOUNT_CARD}.show-more`,
    defaultMessage: "Show more"
  },
  showLess: {
    id: `${ACCOUNT_CARD}.show-less`,
    defaultMessage: "Show less"
  }
});

export default accountCardMessages;
